import { useToastStore } from '../../lib/toast-store'
import { cn } from '../../lib/cn'

const variantStyles = {
  error: 'bg-red-50 text-red-700 border border-red-200/80',
  success: 'bg-stone text-foreground border border-foreground/10',
} as const

export function ToastViewport() {
  const toasts = useToastStore((s) => s.toasts)

  if (toasts.length === 0) return null

  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed bottom-6 left-1/2 z-50 flex w-full max-w-sm -translate-x-1/2 flex-col items-center gap-2 px-4"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          className={cn(
            'pointer-events-auto w-full animate-toast-in rounded-full px-4 py-2 text-center text-sm shadow-md',
            variantStyles[toast.variant],
          )}
        >
          {toast.message}
        </div>
      ))}
    </div>
  )
}
